import styled, {css} from 'styled-components';
import {commonPalette} from 'styles/palette';
import {noSelect, ellipsis} from 'utils/sc-utils';
import {Button as $Button} from 'components/Button';
import $Icon from 'components/Icon';

export const SelectWrapper = styled.div`
  opacity: ${({disabled}) => (disabled ? 0.5 : 1)};
  display: ${({display}) => display ?? 'flex'};
  flex-direction: ${p => (p.underlined ? 'row' : 'column')};
  align-items: ${p => (p.underlined ? 'center' : 'flex-start')};
  position: relative; // to preserve popover position while scrolling
  width: 100%;

  ${() => Label} {
    font-size: 14px;
    line-height: 20px;
    color: ${commonPalette.textSecondary};
    margin: 0 0 4px;

    ${p =>
      p.underlined &&
      `
      color: ${commonPalette.txGrey};
      margin: 0 10px 0 0;

      :after {
        content: ':';
      }
    `}
  }
`;

export const Label = styled.label``;
export const Button = styled($Button)``;
export const Icon = styled($Icon)``;

export const Select = styled.div`
  width: ${({width}) => (width ? `${width}px` : '100%')};
  height: 40px;
  border: 1px solid ${commonPalette.borderGrey};
  border-radius: 4px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: border-color 0.2s easy-in-out;
  cursor: pointer;
  background-color: #fff;
  overflow: hidden;

  ${p =>
    p.disabled &&
    `
    background-color: ${commonPalette.lightGrey};
    color: ${commonPalette.txLightGrey};
    cursor: default;
  `}

  ${p =>
    p.showSearch &&
    `
    cursor: text;
  `}

  ${() => Button} {
    > svg {
      margin: 0 0 0 10px;
      transform: rotate(0deg);
      transition: transform 0.2s linear;

      ${p =>
        p.open &&
        `
        transform: rotate(180deg);
        transition: transform 0.2s linear;
      `}
    }
  }
`;

export const UserInput = styled.input`
  border: none;
  width: 88%;
  background: none;

  &:not(:disabled) {
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${commonPalette.txLightGrey};
  }
`;

export const OptionsWrapper = styled.div`
  max-height: 200px;
  overflow: auto;
  scrollbar-width: none;
  overscroll-behavior: contain;
`;

export const baseOption = css`
  height: 40px;
  font-size: 14px;
  padding: 0 16px;
  text-align: left;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 100ms linear;

  &:hover {
    background-color: ${commonPalette.lightGrey};
  }
`;

export const Option = styled.div`
  ${noSelect}
  ${ellipsis}
  ${baseOption}

  color: ${p => (p.selected && !p.popover ? commonPalette.sgGreen : commonPalette.txBlack)};
  font-weight: ${p => (p.selected || !p.popover ? 400 : 300)};

  ${p =>
    p.disabled &&
    `
    color: ${commonPalette.txLightGrey};
    cursor: default;
  `}

  &:hover {
    background-color: ${commonPalette.lightGrey};
  }

  .icon {
    margin: 0 0 0 auto;
    ${p => !p.popover && `color: ${commonPalette.sgGreen};`}
  }

  ${p =>
    p.popover &&
    `

    &:after {
      content:"";
      position: absolute;
      bottom: 0;
      left: 16px;
      right: 16px;
      border-bottom: 1px solid #e0e0e0;
    }

    &:last-child:after {
      border-bottom: none;
    }
  `}

  ${() => Icon} {
    margin-right: 8px;
  }
`;

export const SkeletonOption = styled.div`
  ${baseOption}
`;

export const Chevron = styled($Icon).attrs({
  name: 'chevron-down'
})`
  pointer-events: none;
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: ${({opened}) => (opened ? 'translateY(-50%) rotate(-180deg)' : 'translateY(-50%)')};
  transition: transform 0.2s linear;
`;

export const CheckMark = styled($Icon).attrs({
  name: 'checkmark'
})`
  pointer-events: none;
  right: 1rem;
`;

export const Close = styled($Icon).attrs({
  name: 'close'
})`
  pointer-events: none;
  position: absolute;
  right: 1rem;
  top: 50%;
`;

export const SkeletonDiv = styled.div`
  height: 21px;
  width: ${p => p.width ?? '100%'};
  background-color: ${commonPalette.darkestGray};
  animation: skeleton-loading 500ms linear infinite alternate;

  @keyframes skeleton-loading {
    0% {
      background-color: ${commonPalette.darkestGray}; /* FROM Color 1 */
    }
    100% {
      background-color: ${commonPalette.lightGrey}; /* TO Color 2 */
    }
  }
`;

export const FeedbackText = styled.p`
  margin-top: 8px;
  font-size: 12px;
  line-height: 16px;
  color: ${commonPalette.textSecondary};
`;
